export default "__VITE_ASSET__ab60356c__"